function SecondQuoteSection() {

    return (
        <section>
            <div className="quote-section">
                <div className="quote-mark">"</div>
                <div className="quote">Your vision will become clear only when you can look into your own heart. Who looks outside, dreams; Who looks inside, awakes</div>
                <div className="sig">Carl Jung</div>
            </div>
        </section>
    );
}

export default SecondQuoteSection;